import React, {useEffect, useState} from 'react'
import {searchRegions} from '../core/_requests'
import type {RegionOption} from '../core/_models'

export const RequisitionRegionField = ({
  regionId, regionName, onChange,
}: {regionId: number | null; regionName?: string | null; onChange: (id: number | null, name: string | null) => void}) => {
  const [query, setQuery] = useState('')
  const [results, setResults] = useState<RegionOption[]>([])
  useEffect(() => {
    if (query.trim().length < 2) { setResults([]); return }
    let active = true
    const timer = window.setTimeout(() => {
      searchRegions(query.trim()).then((rows) => { if (active) setResults(rows) })
    }, 250)
    return () => { active = false; window.clearTimeout(timer) }
  }, [query])
  return <div>
    <label className='form-label fw-semibold fs-6 mb-2'>Region</label>
    <input className='form-control' value={query} onChange={(event) => setQuery(event.target.value)}
      placeholder='Search continent, country, or city' aria-label='Search requisition region' />
    {regionId != null && <div className='mt-2'>
      <span className='badge bg-light text-dark border'>{regionName || `Region #${regionId}`}</span>
      <button type='button' className='btn btn-sm btn-light ms-2' onClick={() => { onChange(null, null); setQuery('') }}>Clear</button>
    </div>}
    {results.length > 0 && <div className='border rounded p-2 mt-2' style={{maxHeight: 180, overflowY: 'auto'}}>
      {results.map((region) => <button key={region.id} type='button' className='btn btn-sm btn-light w-100 text-start mb-1'
        onClick={() => { onChange(region.id, region.path); setQuery(''); setResults([]) }}>{region.path}</button>)}
    </div>}
  </div>
}
